import {Injectable} from '@angular/core';

import {ValidatorProvider} from '../../providers/validator/validator';
import {AuthProvider} from '../../providers/auth/auth';
import {ProofServerProvider} from "../../providers/proof-server/proof-server";

import * as Config from "../../app/app.config";

/*
  Generated class for the RegistrationProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class RegistrationProvider {

  private proof = null;

  constructor(
    private validatorProvider: ValidatorProvider,
    private authProvider: AuthProvider,
    private proofServerProvider: ProofServerProvider
  ) {
    console.log('Hello RegistrationProvider Provider');

    this.proofServerProvider.getById(Config.proofId).subscribe(proof => {
      this.proof = proof;
    });
  }

  // public isComplete(callback = null): boolean {
  //   const user = this.authProvider.getUser();
  //   const isValid: boolean = (
  //       (!this.validatorProvider.isEmpty(user.address)) &&
  //       (!this.validatorProvider.isEmpty(user.addressNumber)) &&
  //       (!this.validatorProvider.isEmpty(user.addressCountry)) &&
  //       (!this.validatorProvider.isEmpty(user.addressCity)) &&
  //       (!this.validatorProvider.isEmpty(user.addressState)) &&
  //       (!this.validatorProvider.isEmpty(user.addressZip))) &&
  //       (user.genre !== null) &&
  //       (user.nationality !== null) &&
  //       (!this.validatorProvider.isEmpty(user.birthPlace)) &&
  //       (!this.validatorProvider.isEmpty(user.motherName)) &&
  //       (user.documentKind !== null) &&
  //       (!this.validatorProvider.isEmpty(user.documentCode)) &&
  //       (user.scholarity !== null) &&
  //       ((!this.validatorProvider.isEmpty(user.affiliatedFederalCode)) || (user.affiliatedAccepted === false && user.affiliatedAware !== null));
  //
  //   if (callback === null) {
  //     return isValid;
  //   } else {
  //     this.proofServerProvider.getById(Config.proofId).subscribe(proof => {
  //       if (proof.hasMandatoryDocumentation === '1' /* && user.userFiles.length === 0 */) {
  //         callback(false);
  //       } else {
  //         callback(isValid);
  //       }
  //     });
  //   }
  // }
  public isComplete(callback = null): boolean {
    const user = this.authProvider.getUser();

    const isValid: boolean =
      [
        user.address,
        user.addressNumber,
        user.addressCountry,
        user.addressCity,
        user.addressState,
        user.addressZip,
        user.birthPlace,
        user.motherName,
        user.documentCode,
      ].every(value => !this.validatorProvider.isEmpty(value)) &&
      user.genre !== null &&
      user.nationality !== null &&
      user.documentKind !== null &&
      user.scholarity !== null &&
      (
        !this.validatorProvider.isEmpty(user.affiliatedFederalCode) ||
        (user.affiliatedAccepted === false && user.affiliatedAware !== null)
      );

    if (callback === null) {
      return isValid;
    }

    this.proofServerProvider.getById(Config.proofId).subscribe(proof => {
      if (
        proof.hasMandatoryDocumentation === '1' /* && user.userFiles.length === 0 */
      ) {
        callback(false);
        return;
      }

      callback(isValid);
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/registration/registration.ts